const getCurrencySymbol = (type,code,byCode) => {
	if(type) {
		type = type.toString();
	}
	if(byCode) {
		if(type === 'EUR') {
			return code ? '2' : '€'
		}
		else if(type === 'USD') {
			return code ? '3' : "$";
		}
		else {
			return code ? '1' : "₺";
		}
	}
	else {
		if(type === '2') {
			return code ? 'EUR' : "€";
		}
		else if(type === '3') {
			return code ? 'USD' : "$";
		}
		else {
			return code ? 'TRY' : "₺";
		}
	}
}

export default getCurrencySymbol